<template>
  <div class="flex flex-col border border-dark-gray rounded-lg bg-white" v-click-outside="onHideSearch">
    <div class="flex items-center p-x-2 border-b border-gray-light" v-if="!exportPdf">
      <svg class="flex-shrink-0" width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m19.154 18.29-4.17-4.17a5.777 5.777 0 0 0 1.293-3.647 5.812 5.812 0 0 0-5.805-5.806 5.812 5.812 0 0 0-5.805 5.806c0 3.2 2.604 5.806 5.805 5.806 1.381 0 2.65-.487 3.647-1.295l4.17 4.17a.61.61 0 0 0 .865 0 .61.61 0 0 0 0-.863Zm-8.682-3.234a4.588 4.588 0 0 1-4.583-4.583 4.588 4.588 0 0 1 4.583-4.583 4.588 4.588 0 0 1 4.583 4.583 4.588 4.588 0 0 1-4.583 4.583Z" fill="#9AA3B0"/></svg>

      <input 
        type="text" 
        class="border-0 bg-transparent m-r-auto p-y-2 p-x-2" 
        placeholder="Search vessel" 
        v-model="search" 
        @keyup="onKeyUp"
        ref="search"
        @keyup.enter="$event.target.blur()"
        :disabled="!isAllow"
      >

      <button 
        v-if="!search && !exportPdf && isAllow && !replaceMode"
        class="m-r-1 text-blue-dark whitespace-nowrap fz14 fw500"
        @click="$emit('on-create')" 
      >Create vessel</button>
      <button v-else-if="!exportPdf && search" class="fz0" @click="onHideSearch">
        <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.514 7.579a.75.75 0 0 1 0-1.067.767.767 0 0 1 1.078 0l9.894 9.785a.75.75 0 0 1 0 1.068.767.767 0 0 1-1.078 0L6.514 7.579Z" fill="#9AA3B0"/><path d="M16.409 6.635a.767.767 0 0 1 1.077 0 .75.75 0 0 1 0 1.068l-9.894 9.786a.767.767 0 0 1-1.078 0 .75.75 0 0 1 0-1.068l9.895-9.786Z" fill="#9AA3B0"/></svg>
      </button>
    </div>

    <div class="flex h-full overflow-hidden relative">
      <div class="absolute w-full h-full overflow-y-auto" v-if="isSearchFocus || replaceMode" :class="{'d-flex align-items-center justify-center': !searchList || !searchList.length || !search.length}">
        <app-loader v-if="isSearchLoad" :isLocal="true"/>

        <div class="p-x-3 p-y-1.5 fz14 fw500" v-if="replaceMode && !search.length">Enter in the search the name of the vessel you want to replace with</div>
        <div class="p-x-3 p-y-1.5 fz14 fw500" v-if="(!searchList || !searchList.length) && search.length">The vessel list is empty</div>
        <div 
          class="flex items-center p-l-3 p-r-2 cursor-pointer fz14 hover:bg-gray-lightest"
          :class="{
            'bg-gray-lightest': vessels.find(el=>el.vessel ? el.vessel==item.id : el.id==item.id)
          }"
          v-for="item in searchList" 
          :key="item.id"
          @click="onPin(item)"
        >
          <span 
            class="p-y-1.5 overflow-ellipsis overflow-hidden whitespace-nowrap"
            v-tooltip="item.name"
          >
            <span class="text-gray-text">(#{{item.id}})</span>
            {{item.name}} {{item.dwt && item.built ? ` - ${item.dwt} - ${item.vessel_type === 'parsed' ? getYearStr(item.built) : item.built}` : ''}}
          </span>
          <svg v-on:click="save" v-if="beforePinVesels.find(el=>el.id==item.id)" class="m-l-auto flex-shrink-0" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.9783 6.2675C17.6651 5.91943 17.1483 5.90978 16.8239 6.24594C16.8172 6.25297 16.8105 6.26016 16.8039 6.2675L10.535 14.8915L7.38355 12.2611C7.05922 11.9249 6.54241 11.9345 6.22918 12.2826C5.92361 12.6222 5.92361 13.1604 6.22918 13.5L9.95778 16.7499C10.2766 17.092 10.7934 17.092 11.1121 16.7499L17.9582 7.50645C18.2826 7.17023 18.2915 6.61558 17.9783 6.2675Z" fill="#319FEF"/></svg>
        </div>
      </div>

      <div v-else-if="!vessels || !vessels.length" class="m-auto text-align-center">
        <svg width="152" height="100" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.176 77.516 3.469 64.99V53.915h7.516m117.847 24.738 19.704-24.739h-42.709l-4.772 4.288H37.23m-26.245-4.288h15.15l4.772 4.288h6.323m-26.245-4.288v-6.383m0 0H37.23m-26.245 0H8.479v-3.143h6.204v-6.265m22.547 9.408h2.386v-3.143H37.23v-6.265m0 9.408v10.67m0-20.078H14.683m22.547 0h2.386V34.98H37.23v-5.955h-4.294m-18.253 9.098h-2.386V34.98h10.856m9.782-5.955-5.964 5.955h-3.818m9.782-5.955v-5.55M23.153 34.98l1.945-11.504m.614-3.692.634-3.977h6.59v3.977m-7.224 0h7.223m-7.223 0-.614 3.692m7.837-3.692v3.692m0 0h-7.837" stroke="#DEE3EA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M78.856 14.862c0-2.243-1.492-2.33-2.345-2.535-.19-.76-.832-2.618-3.22-2.766-2.386-.148-3.6 1.403-3.954 2.245-1.35 0-4.76.467-4.76 3.056 0 2.072 2.179 2.63 3.268 2.651h8.027c.995-.103 2.984-.777 2.984-2.65ZM105.699 29.652c0-5.127 3.163-5.325 4.97-5.795.401-1.738 1.765-5.985 6.825-6.323 5.06-.338 7.632 3.208 8.385 5.134 2.862 0 10.09 1.065 10.09 6.984 0 4.735-4.618 6.013-6.927 6.06h-17.018c-2.108-.235-6.325-1.776-6.325-6.06Z" stroke="#DEE3EA" stroke-width="2"/><path d="M14.316 79.506c1.787 0 3.347-1.144 4.182-2.844.835 1.7 2.395 2.844 4.181 2.844 1.787 0 3.347-1.144 4.182-2.844.835 1.7 2.395 2.844 4.181 2.844 1.787 0 3.347-1.144 4.182-2.844.835 1.7 2.395 2.844 4.181 2.844 1.787 0 3.347-1.144 4.182-2.844.834 1.7 2.395 2.844 4.181 2.844 1.787 0 3.347-1.144 4.182-2.844.834 1.7 2.395 2.844 4.181 2.844 1.787 0 3.347-1.144 4.182-2.844.834 1.7 2.395 2.844 4.181 2.844m12.545-2.844c.835 1.7 2.394 2.844 4.181 2.844s3.347-1.144 4.182-2.844c.835 1.7 2.394 2.844 4.181 2.844s3.347-1.144 4.182-2.844c.835 1.7 2.394 2.844 4.181 2.844s3.347-1.144 4.182-2.844c.834 1.7 2.394 2.844 4.181 2.844s3.347-1.144 4.182-2.844c.834 1.7 2.394 2.844 4.181 2.844s3.347-1.144 4.182-2.844c.834 1.7 2.394 2.844 4.181 2.844s3.347-1.144 4.182-2.844c.834 1.7 2.394 2.844 4.181 2.844M43.629 81.781c.835 1.7 2.395 2.844 4.181 2.844 1.787 0 3.347-1.144 4.182-2.844.835 1.7 2.395 2.844 4.181 2.844 1.787 0 3.347-1.144 4.182-2.844.835 1.7 2.395 2.844 4.181 2.844 1.787 0 3.347-1.144 4.182-2.844.834 1.7 2.395 2.844 4.181 2.844 1.787 0 3.347-1.144 4.182-2.844.834 1.7 2.395 2.844 4.181 2.844 1.787 0 3.347-1.144 4.182-2.844.834 1.7 2.395 2.844 4.181 2.844 1.787 0 3.347-1.144 4.182-2.844.834 1.7 2.395 2.844 4.181 2.844m12.545-2.844c.834 1.7 2.395 2.844 4.181 2.844 1.787 0 3.347-1.144 4.182-2.844.834 1.7 2.395 2.844 4.181 2.844 1.787 0 3.347-1.144 4.182-2.844.834 1.7 2.395 2.844 4.181 2.844 1.787 0 3.347-1.144 4.182-2.844.834 1.7 2.394 2.844 4.181 2.844M6.2 84.625c1.786 0 3.346-1.144 4.18-2.844.835 1.7 2.395 2.844 4.182 2.844 1.787 0 3.347-1.144 4.182-2.844.834 1.7 2.394 2.844 4.181 2.844s3.347-1.144 4.182-2.844c.834 1.7 2.394 2.844 4.181 2.844" stroke="#DEE3EA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><circle cx="12" cy="61" r="2" stroke="#DEE3EA" stroke-width="2"/><circle cx="22" cy="61" r="2" stroke="#DEE3EA" stroke-width="2"/></svg>
        <h3 class="m-t-4 fz18 fw500">The vessel list is empty</h3>
      </div>

      <div v-else class="absolute w-full h-full overflow-y-auto">
        <div class="calc_vessels__list_row border-b border-gray-light bg-gray-dark fz13 text-gray-text">
          <div class="p-l-10 p-r-2 p-y-1">Vessel name</div>
          <div class="p-x-2" v-tooltip="'DWT'">DWT</div>
          <div class="p-x-2" v-tooltip="'Built'">Built</div>
          <div class="p-x-2" v-tooltip="'Hire'">Hire</div>
          <div class=""></div>
        </div>

        <calc-vessels-list-row
            @renamed="(e)=>{$emit('renamed', e)}"
            :exportPdf="exportPdf"
          :class="{
            'bg-blue-lightest color-all-blue' : selectedId == vessel.id
          }"
          v-for="vessel in getVessels" 
          :key="vessel.id"
          :vessel="vessel"
            @on-replace="$emit('on-replace', vessel)"
            @on-duplicate="$emit('on-duplicate', vessel)"
          @on-delete="$emit('on-delete', vessel.id)"
          @on-select="$emit('on-select', vessel.id)"
          @on-calc="$emit('on-calc', vessel)"
            @
          :isAllow="isAllow"
        />

      </div>
    </div>
  </div>
</template>

<script>
import appLoader from "@/components/loader"
import calcVesselsListRow from "@/components/calc/calcVesselsListRow"
import moment from 'moment'

import { mapActions } from 'vuex'

export default {
  components: {
    appLoader,
    calcVesselsListRow
  },
  props: {
    isAllow: Boolean,
    vessels: Array,
    selectedId: Number,
    exportPdf: {
      type: Boolean,
      default: false,
    },
    replaceMode: Boolean,

  },
  data() {
    return {
      search: '',
      isSearchLoad: false,
      isSearchFocus: false,
      timeout: null,
      searchList: null,
      beforePinVesels: []
    }
  },
  computed: {
    getVessels() {
      let favorite = this.vessels.filter(el=>el.is_favorite)
      let not_favorite = this.vessels.filter(el=>!el.is_favorite)
      return [...favorite, ...not_favorite]
    }
  },
  watch: {
    replaceMode: function () {
      if(this.replaceMode) {
        this.$refs.search.focus()
      }
    }
  },
  methods: {
    ...mapActions(['axiosGetCalcVesselList']),
    getYearStr(date) {
      return moment(date).format('YYYY')
    },
    onKeyUp() {
      this.isSearchFocus = true
      if(this.timeout) clearTimeout(this.timeout)
      if(this.search){
        this.timeout = setTimeout(()=>{
          this.onSearch()
        }, 600)
      }else{
        this.onHideSearch()
      }
    },
    async onSearch() {
      this.isSearchLoad = true
      this.searchList = await this.axiosGetCalcVesselList(this.search)
      this.isSearchLoad = false
    },
    onHideSearch() {
      if(this.timeout) clearTimeout(this.timeout)
      this.searchList = null
      this.search = ''
      this.isSearchFocus = false
      // if(this.beforePinVesels?.length){
      //   this.$emit('on-pin', this.beforePinVesels)
        this.beforePinVesels = []
      // }
      this.$emit('replaceModeOff')
    },
    save() {

      if(this.beforePinVesels?.length){
        if(!this.replaceMode) {
          this.$emit('on-pin', this.beforePinVesels)
        } else {
          this.$emit('on-replace-save', this.beforePinVesels)
        }
        this.beforePinVesels = []
      }
      this.onHideSearch()
    },
    onPin(vessel) {
      if(!this.beforePinVesels.find(el=>el.id==vessel.id) && !this.vessels.find(el=>el.id==vessel.id)){
        this.beforePinVesels.push(vessel)
      }else if(this.beforePinVesels.find(el=>el.id==vessel.id)){
        let index = this.beforePinVesels.findIndex(el=>el.id==vessel.id)
        this.beforePinVesels.splice(index, 1)
      }
      this.save()
    },
  }
}
</script>

<style scoped lang="scss">
  .rounded-lg {
    border-radius: 8px 0 0 8px;
  }
  .color-all-blue {
    /deep/ {
      &>*, input {
        color: var(--color-blue) !important;
        -webkit-text-fill-color: var(--color-blue);
        font-weight: 600;
      }
    }
  }
</style>